import script from "./VoucherRecommendedForYou.vue?vue&type=script&setup=true&lang=ts"
export * from "./VoucherRecommendedForYou.vue?vue&type=script&setup=true&lang=ts"

import "./VoucherRecommendedForYou.vue?vue&type=style&index=0&id=487e13c8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-487e13c8"]])

export default __exports__